/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryQuestionRisk extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryQuestionRisk");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryQuestionRisk.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryQuestionRisk>): AssessmentViewQueryQuestionRisk {
        let obj = Object.assign(new AssessmentViewQueryQuestionRisk(), model);
        AssessmentViewQueryQuestionRisk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryQuestionRisk>): AssessmentViewQueryQuestionRisk {
        if (!model) return null;
        return AssessmentViewQueryQuestionRisk.newInstance(<AssessmentViewQueryQuestionRisk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryQuestionRisk) {
        if (!obj) return;

        models.AssessmentViewQueryQuestionRisk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryQuestionRisk): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryQuestionRisk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Risk of question
     */
    question_risks: Array<models.WellArchitectedFrameworkRisk>;

}
